export default function HeroSection() {
  const handleScroll = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section
      id="home"
      className="relative w-full min-h-screen flex items-center justify-center overflow-hidden"
    >
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/4ef46cbbdb6cc8ccebd3a3a2955f298b.jpg"
          alt="TIAS OOD Hero Background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-black/70" />
      </div>

      {/* Content */}
      <div className="relative z-10 w-full text-center px-6 lg:px-12 max-w-5xl mx-auto">
        <div className="inline-flex items-center gap-2 bg-amber-500/20 border border-amber-500/30 text-amber-400 text-xs font-semibold uppercase tracking-widest px-4 py-2 rounded-full mb-8">
          <span className="w-1.5 h-1.5 bg-amber-400 rounded-full inline-block" />
          iOS Application Development
        </div>
        <h1 className="text-5xl lg:text-7xl font-bold text-white leading-tight tracking-tight mb-6">
          Crafting Premium{" "}
          <span className="text-amber-400">iOS Experiences</span>
        </h1>
        <p className="text-lg lg:text-xl text-white/70 max-w-2xl mx-auto leading-relaxed mb-10">
          TIAS OOD is a team of experts dedicated to building powerful, elegant
          applications for the iOS platform — elevating security and performance
          for mobile users worldwide.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <button
            onClick={() => handleScroll("products")}
            className="px-8 py-3.5 bg-amber-500 hover:bg-amber-400 text-black font-semibold rounded-lg transition-all duration-200 text-sm cursor-pointer whitespace-nowrap"
          >
            Explore Our Products
          </button>
          <button
            onClick={() => handleScroll("about")}
            className="px-8 py-3.5 border border-white/30 hover:border-white/60 text-white font-semibold rounded-lg transition-all duration-200 text-sm cursor-pointer whitespace-nowrap"
          >
            Learn About Us
          </button>
        </div>
      </div>

      {/* Scroll hint */}
      <div className="absolute bottom-10 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 text-white/40">
        <span className="text-xs tracking-widest uppercase">Scroll</span>
        <div className="w-px h-10 bg-white/20 animate-pulse" />
      </div>
    </section>
  );
}
